import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { min } from 'date-fns';
import { UserManagementService } from 'src/app/services/user_management/user-management.service';

@Component({
  selector: 'app-add-single-user',
  templateUrl: './add-single-user.component.html',
  styleUrls: ['./add-single-user.component.scss']
})
export class AddSingleUserComponent {
  userForm!: FormGroup;
  managerAccessListArray: any[] = [];
  selectedAccessKeys: boolean[] = [];
  userArray: any[] = [];
  selectAllChecked: boolean = false;
  isSelectedAll: boolean = false;
  public isShowPassword: boolean = true;
  public isShowCPassword: boolean = true;

  constructor(
    private fb: FormBuilder, private userManagement: UserManagementService, public dilogRef: MatDialogRef<AddSingleUserComponent>
  ) {
    this.userForm = this.fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(8)]],
      accessKeys: [''],
    }, { validator: this.passwordMatchValidator });
  }

  ngOnInit() {
    this.onGetManagerAccessDetailes()


   

  }

  // Function to toggle "Select All"
  toggleSelectAll() {
    this.selectedAccessKeys = this.selectedAccessKeys.map(() => this.isSelectedAll);
  }



  onGetManagerAccessDetailes() {
    let data = {}
    this.userManagement.managerAccessDetails(data).subscribe((response: any) => {
      if (response.status == 200) {
        this.managerAccessListArray = response.msg;

        this.selectedAccessKeys = new Array(this.managerAccessListArray.length).fill(false);
      }
    })
  }

  passwordMatchValidator(group: FormGroup) {
    const password = group.get('password')?.value;
    const confirmPassword = group.get('confirmPassword')?.value;
    return password && confirmPassword && password === confirmPassword
      ? null
      : { mismatch: true };
  }


  onSubmit() {


    if (this.userForm.invalid) {
      // Mark all fields as touched to trigger validation error messages
      this.userForm.markAllAsTouched();

      return;
    }


    // Get the selected access keys based on the checkbox states
    const selectedKeys = this.selectedAccessKeys
      .map((isSelected, index) => isSelected ? this.managerAccessListArray[index].access_key : null)
      .filter((value: string | null) => value !== null);
      this.userArray = []
    const userDet = {
      f_n: this.userForm.value.firstName,
      l_n: this.userForm.value.lastName,
      el: this.userForm.value.email,
      pwd: this.userForm.value.password,
      c_pwd: this.userForm.value.confirmPassword,
      access: JSON.stringify(selectedKeys)
    }
    this.userArray.push(userDet);

    let obj: {} = {
      "u_t": 'manager',
      "u_d": this.userArray,
    }

    this.userManagement.addUser(obj).subscribe({
      next: (data) => {
        if (data.status == 200) {
          this.userArray = []
          this.dilogRef.close()

        }
      },
      error: (error: any) => {
        this.userArray = []
        // this.dilogRef.close()
      },

    });


  }


  onClose() {
    this.dilogRef.close()
  }
  toggleShowPassword(value: any) {
    if (value == 'password') {
      this.isShowPassword = !this.isShowPassword
    }
    else {
      this.isShowCPassword = !this.isShowCPassword
    }
  }
}
